import * as React from 'react';
import './_ViewSettings.scss';
import { IViewSettingsProps } from './types';
import { CLASS_LIST_VIEW } from '../../constants';
import { SettingsSection } from '../../../base/components/SettingsSection/SettingsSection';
import { EXPAND_GROUP, GROUP_EPIC, VIEW_SETTINGS } from './constants';
import { Switch } from 'kui';
import { AnalyzeRender } from '../../../helpers/memoizeHelper';

// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`listView viewSettings`) : null;

export function ViewSettings({
    isExpand,
    isGroupEpic,
    onToggleExpand,
    onToggleGroupEpic,
}: IViewSettingsProps) {
    if (analyzeRender) analyzeRender.call('viewSettings');

    const className = CLASS_LIST_VIEW + '-view-settings';
    const classToggle = className + '__toggle';

    return <SettingsSection className={className} title={VIEW_SETTINGS}>
        <div className={classToggle}>
            {GROUP_EPIC}
            <Switch checked={isGroupEpic} onChange={onToggleGroupEpic}/>
        </div>
        <div className={classToggle}>
            {EXPAND_GROUP}
            <Switch checked={isExpand} onChange={onToggleExpand} disabled={!isGroupEpic} />
        </div>
    </SettingsSection>;
};
